/* eslint-disable react/jsx-no-target-blank */
import { Checkbox, Col, Divider, Image, Input, Row } from "antd";
import React from "react";

function NewSidebar() {
  // icons style
  const iconsStyle =
    "mr-[10px] rounded-full bg-[#161616] flex items-center justify-center w-[35px] h-[32px] cursor-pointer";

  const data = [
    {
      NewsPostImage: "/recentNews.svg",
      type: "Shopping",
      description: "People are strange when you are stranger",
      date: "June 15, 2022",
    },
    {
      NewsPostImage: "/recentNews.svg",
      type: "Tips n Tricks",
      description: "When the musics over turn off the light",
      date: "June 15, 2022",
    },
    {
      NewsPostImage: "/recentNews.svg",
      type: "Shopping",
      description: "When the musics over turn off the light",
      date: "June 15, 2022",
    },
    {
      NewsPostImage: "/recentNews.svg",
      type: "Tips n Tricks",
      description: "People are strange when you are stranger",
      date: "June 15, 2022",
    },
  ];

  const onChange = (e) => {
    // console.log(`checked = ${e.target.checked}`);
  };

  return (
    <div>
      <div>
        <p className="text-xl text-[#ffffff] font-medium">Search</p>
        <Divider className="text-[#ffffff]" />
        <Input
          placeholder="Search"
          className="!bg-[#434242] !border-[#434242]"
        />
        <p className="text-xl mt-14 text-[#ffffff] font-medium">Recent Posts</p>
        <Divider className="text-[#ffffff]" />
        <br />
        <div className="!mt-[-28px]">
          {data?.map((val) => {
            return (
              <div className="flex mt-4">
                <Image
                  src={val?.NewsPostImage}
                  alt={val?.type}
                  preview={false}
                  className="!w-28 !h-28"
                />
                <div className="flex flex-col ml-2">
                  <p className="text-sm font-normal	text-[#ffffff]">
                    {val?.type}
                  </p>
                  <p className="text-sm font-semibold	text-[#ffffff]">
                    {val?.description}
                  </p>
                  <p className="text-sm font-normal text-[#ffffff]">
                    {val?.date}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <p className="text-xl mt-14 text-[#ffffff] font-medium">Categories</p>
        <Divider className="text-[#ffffff]" />
        <div className="flex flex-col ">
          <Checkbox onChange={onChange}>
            <span className="text-[#ffffff]">Blog</span>
          </Checkbox>
          <Checkbox onChange={onChange}>
            <span className="text-[#ffffff]">Press</span>
          </Checkbox>
          <Checkbox onChange={onChange}>
            <span className="text-[#ffffff]">Podcast</span>
          </Checkbox>
          <Checkbox onChange={onChange}>
            <span className="text-[#ffffff]"> Sweets bakery</span>
          </Checkbox>
          <Checkbox onChange={onChange}>
            <span className="text-[#ffffff]">Runway</span>
          </Checkbox>
        </div>
        <p className="text-xl mt-14 text-[#ffffff] font-medium">Gallery</p>
        <Divider className="text-[#ffffff]" />
        <div>
          <Row gutter={[8, 8]}>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
          </Row>
          <Row gutter={[8, 8]}>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
          </Row>
          <Row gutter={[8, 8]}>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
            <Col span={8}>
              <Image
                src="/galleryGirl.svg"
                alt="gallery"
                preview={false}
                className="!w-28 !h-28"
              />
            </Col>
          </Row>
        </div>
        <p className="text-xl mt-14 text-[#ffffff] font-medium">Follow Us</p>
        <Divider className="text-[#ffffff]" />
        <div className="flex items-center">
          <a href="https://www.facebook.com/metaworld.x" target="_blank">
            <div className={iconsStyle}>
              <img src="/assets/Facebook.svg" alt="facebook" />
            </div>
          </a>
          <a
            href="https://www.instagram.com/metaworld.x/?igshid=YmMyMTA2M2Y%3D"
            target="_blank"
          >
            <div className={iconsStyle}>
              <img src="/assets/Instagram.svg" alt="instagram" />
            </div>
          </a>
          <a href="https://twitter.com/MetaWorldX" target="_blank">
            <div className={iconsStyle}>
              <img src="/assets/Twitter.svg" alt="twitter" />
            </div>
          </a>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
}

export default NewSidebar;
